export const SET_TEMPORARY_CUSTOMER = 'SET_TEMPORARY_CUSTOMER';
export const UPDATE_TEMPORARY_CUSTOMER = 'UPDATE_TEMPORARY_CUSTOMER';
export const UPDATE_TEMPORARY_CUSTOMER_EMAIL = 'UPDATE_TEMPORARY_CUSTOMER_EMAIL';
export const UPDATE_SPONSOR = 'UPDATE_SPONSOR';
export const VALID_SPONSOR_CODE = 'VALID_SPONSOR_CODE';
export const RETRIEVE_LOCALSTORAGE = 'RETRIEVE_LOCALSTORAGE';
export const UPDATE_TRACKED_URL = 'UPDATE_TRACKED_URL';
